import {DataStatus, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {
  useFacebookAuthenticateMutation,
  useGetFacebookExtraLinkQuery,
  useGetFacebookPlatformQuery,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {testIds} from '@dms/routes';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormUrlExport,
  PlatformAuthenticationFormUrlExportProps,
} from './components/PlatformAuthenticationFormUrlExport';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsFacebook() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetFacebookPlatformQuery({params});
  const {data: extraLinkData} = useGetFacebookExtraLinkQuery(params);
  const [saveAuthentication] = useFacebookAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormUrlExportProps['onSubmit'] = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .then(() => showNotification.success())
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && isNotNil(extraLinkData) && (
          <PlatformAuthenticationFormUrlExport
            defaultValues={data.credentials}
            extraLink={extraLinkData.link}
            onSubmit={onSubmitCredentials}
            data-testid={testIds.settings.advertisingPlatforms(
              'platformAuthenticationFormUrlExport'
            )}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.FACEBOOK} />
      </DataStatus>
    </Show>
  );
}
